import type { LeadTagDto, TagColor } from '@performance-crm/shared';
import { TAG_COLOR_CLASSES } from '@/components/leads/tagColors';
import { cn } from '@/lib/utils';

export function TagChip({
  tag,
  size = 'sm',
  className,
}: {
  tag: { name: string; color: TagColor };
  size?: 'xs' | 'sm';
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex max-w-[160px] items-center truncate rounded-full border font-medium',
        size === 'xs' ? 'px-1.5 py-0 text-[10px] leading-4' : 'px-2 py-0.5 text-xs',
        TAG_COLOR_CLASSES[tag.color] ?? TAG_COLOR_CLASSES.gris,
        className,
      )}
      data-testid="tag-chip"
      title={tag.name}
    >
      {tag.name}
    </span>
  );
}

/** Hasta `max` etiquetas y un "+n" con el resto (tabla, tarjetas del tablero). */
export function TagChips({
  tags,
  max = 3,
  size = 'xs',
}: {
  tags: LeadTagDto[];
  max?: number;
  size?: 'xs' | 'sm';
}) {
  if (tags.length === 0) return null;
  const shown = tags.slice(0, max);
  const rest = tags.length - shown.length;
  return (
    <span className="inline-flex flex-wrap items-center gap-1" data-testid="tag-chips">
      {shown.map((t) => (
        <TagChip key={t.id} tag={t} size={size} />
      ))}
      {rest > 0 && (
        <span
          className="text-muted-foreground text-[10px]"
          title={tags
            .slice(max)
            .map((t) => t.name)
            .join(', ')}
        >
          +{rest}
        </span>
      )}
    </span>
  );
}
